module.exports = __webpack_public_path__ + "img/biometric.b4ad23d0.jpg";